import type { TableColumn } from "@prequel/shared-components";

/** Uppercase small-caps headers shared by the detail-page schema and mapping tables. */
export const schemaColumns = (labels: string[]): TableColumn[] =>
  labels.map((label) => ({
    id: label,
    header: <span className="text-xs tracking-wide text-stone-500 uppercase">{label}</span>,
  }));
